import { useQuery } from "@tanstack/react-query";
import {
  DoubleMaterialitySurveyDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_DOUBLE_MATERIALITY } from "../domain";

import { roleGuard } from "@api";
import { doubleMaterialitySurveysApi } from "@api/services";


export const ACTION_GET_SURVEYS = "GET_SURVEYS";

const getSurveys = async (): Promise<DoubleMaterialitySurveyDto[]> => {
  const res =
    await doubleMaterialitySurveysApi.doubleMaterialitySurveysControllerFindAll();

  return res.data || [];
};

export const useGetSurveys = (
  user: UserProfileDto | null,
): {
  surveys?: DoubleMaterialitySurveyDto[];
  surveysEnabled: boolean;
  isPending: boolean;
  refetchSurveys: () => void;
} => {
  const surveysEnabled = roleGuard(user, [UserRole.Owner, UserRole.Manager]);
  const { data, isPending, refetch } = useQuery({
    queryKey: [DOMAIN_DOUBLE_MATERIALITY, ACTION_GET_SURVEYS],
    queryFn: getSurveys,
    enabled: surveysEnabled,
    staleTime: 2 * 60 * 1000,
  });

  return { surveys: data, surveysEnabled, isPending, refetchSurveys: refetch };
};
